/* eslint-disable react/prop-types */
import React from "react";
import { Box, Skeleton } from "@mui/material";
import { useEffect, useState } from "react";

const imgWidthDefault = 250;
const imgHeightDefault = 250;

export default function ImageCard({
  alt = "placeholder",
  src = "/placeholder.jpg",
  imgWidth = imgWidthDefault,
  imgHeight = imgHeightDefault,
}) {
  const [imageLoaded, setImageLoaded] = useState(true);
  const [width, setImgWidth] = useState(imgWidth); // Example initial width
  const [height, setImgHeight] = useState(imgHeight);

  useEffect(() => {
    checkTypes();

    function checkTypes() {
      const widthType = typeof imgWidth;
      const heightType = typeof imgHeight;
      if (widthType === "number" && heightType === "number") {
        setImgWidth(imgWidth);
        setImgHeight(imgHeight);
      } else if (widthType === "string" && heightType === "string") {
        const newWidth = Number(imgWidth);
        const newHeight = Number(imgHeight);
        if (!isNaN(newWidth) && !isNaN(newHeight)) {
          setImgWidth(newWidth);
          setImgHeight(newHeight);
        } else {
          setImgWidth(imgWidthDefault);
          setImgHeight(imgHeightDefault);
        }
      } else {
        setImgWidth(imgWidthDefault);
        setImgHeight(imgHeightDefault);
      }
    }
  }, [imgWidth, imgHeight]);

  return (
    <Box
      style={{
        padding: "0px",
        margin: "0px",
  
        width: `${width}px`,
        height: `${height}px`,
      }}
    >
      <Box
        style={{
          padding: "0px",
          margin: "0px",
          width: `${width}px`,
          height: `${height}px`,
          overflow: "hidden",
          position: "relative",
        }}
      >
        {!imageLoaded && (
          <Skeleton width={`${width}px`} height={`${height}px`} />
        )}

        <img
          src={src}
          alt={alt}
          width={width}
          height={height}
          style={{
            objectFit: "contain",
            objectPosition: "center",
            padding: "0px",
            margin: "0px",
            display: imageLoaded ? "block" : "none",
          }}
          onLoad={() => {
            setImageLoaded(true);
          }}
          loading="lazy"  
        />
      </Box>
    </Box>
  );
}
